export default "__VITE_ASSET__BFoMu3FM__"